import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {
  IResponseCompactTemplate,
  IResponseCreatedByTemplate,
  IResponseGetAllTemplate,
  IResponseGetTemplateAssign,
  ITemplateImportPreview,
  ITemplateImportResult,
} from '@/types';
import {
  AssignTemplateDTO,
  AssignTemplateForDepartmentDTO,
  CreateTemplateDTO,
  DeleteMultipleTemplateDTO,
  DeleteTemplateDTO,
  DetailTemplateDTO,
  DuplicateTemplateDTO,
  GetCreatedByTemplateDTO,
  GetListTemplateAssignDTO,
  GetListTemplateDTO,
  GetListTemplatePartnerDTO,
  GetTemplateCompactDTO,
  HttpService,
  ResponseDTO,
  ShareTemplateForUserDTO,
  UpdateTemplateDTO,
  GetSyncTemplateBODTO,
  SyncTemplateBODTO,
  ExportTemplatesDTO,
  PreviewTemplateImportDTO,
  CommitTemplateImportDTO,
} from '@/shared';

@Service()
export class TemplateService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async getTemplateList(
    getListTemplateDTO: GetListTemplateDTO,
  ): Promise<ResponseDTO<IResponseGetAllTemplate>> {
    return this.httpService.request(getListTemplateDTO);
  }
  public async getTemplateListPartner(
    getListTemplatePartnerDTO: GetListTemplatePartnerDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getListTemplatePartnerDTO);
  }
  public async getTemplateAssignList(
    getListTemplatePartnerDTO: GetListTemplateAssignDTO,
  ): Promise<ResponseDTO<IResponseGetTemplateAssign>> {
    return this.httpService.request(getListTemplatePartnerDTO);
  }
  public async createTemplate(
    createTemplateDTO: CreateTemplateDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(createTemplateDTO);
  }
  public async detailTemplate(
    detailTemplateDTO: DetailTemplateDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(detailTemplateDTO);
  }
  public async updateTemplate(
    updateTemplateDTO: UpdateTemplateDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(updateTemplateDTO);
  }
  public async deleteTemplate(
    deleteTemplateDTO: DeleteTemplateDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(deleteTemplateDTO);
  }
  public async deleteMultiTemplate(
    deleteMultiTemplateDTO: DeleteMultipleTemplateDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(deleteMultiTemplateDTO);
  }
  public async getTemplateCompact(
    getTemplateCompactDTO: GetTemplateCompactDTO,
  ): Promise<ResponseDTO<IResponseCompactTemplate[]>> {
    return this.httpService.request(getTemplateCompactDTO);
  }
  public async shareTemplateForUser(
    shareTemplateForUserDTO: ShareTemplateForUserDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(shareTemplateForUserDTO);
  }
  public async assignTemplateForDepartment(
    assignTemplateForDepartmentDTO: AssignTemplateForDepartmentDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(assignTemplateForDepartmentDTO);
  }
  public async assignTemplate(
    assignTemplateForDepartmentDTO: AssignTemplateDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(assignTemplateForDepartmentDTO);
  }
  public async duplicateTemplate(
    duplicateTemplateDTO: DuplicateTemplateDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(duplicateTemplateDTO);
  }
  public async getCreatedByTemplate(
    getCreatedByTemplateDTO: GetCreatedByTemplateDTO,
  ): Promise<ResponseDTO<IResponseCreatedByTemplate[]>> {
    return this.httpService.request(getCreatedByTemplateDTO);
  }
  public async getSyncTemplateBO(
    getSyncTemplateBODTO: GetSyncTemplateBODTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getSyncTemplateBODTO);
  }
  public async syncTemplateBO(
    syncTemplateBODTO: SyncTemplateBODTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(syncTemplateBODTO);
  }

  public async exportTemplates(
    exportTemplatesDTO: ExportTemplatesDTO,
  ): Promise<ResponseDTO<Blob>> {
    return this.httpService.request(exportTemplatesDTO);
  }

  public async previewTemplateImport(
    previewTemplateImportDTO: PreviewTemplateImportDTO,
  ): Promise<ResponseDTO<ITemplateImportPreview>> {
    return this.httpService.request(previewTemplateImportDTO);
  }

  public async commitTemplateImport(
    commitTemplateImportDTO: CommitTemplateImportDTO,
  ): Promise<ResponseDTO<ITemplateImportResult>> {
    return this.httpService.request(commitTemplateImportDTO);
  }
}
